import {createSelector} from '@ngrx/store';

import {selectChacrasIsLoading} from './entities/shared/chacras/chacras.selectors';
import {selectChacrasGeoIsLoading} from './entities/shared/chacras-geo/chacras-geo.selectors';
import {selectDibujosIsLoading} from './entities/shared/dibujos/dibujos.selectors';
import {selectEmpresasIsLoading} from './entities/shared/empresas/empresas.selectors';
import {selectPersonasIsLoading} from './entities/shared/personas/personas.selectors';
import {selectRolesIsLoading} from './entities/shared/roles/roles.selectors';
import {selectRolesArcgisIsLoading} from "./entities/shared/roles-arcgis/roles-arcgis.selectors";
import {selectAdjuntosIsLoading} from "./entities/shared/adjuntos/adjuntos.selectors";
import {selectMensajesIsLoading} from "./entities/shared/mensajes/mensajes.selectors";
import {selectSuelosIsLoading} from "./entities/shared/suelos/suelos.selectors";
import {selectCultivosIsLoading} from "./entities/shared/cultivos/cultivos.selectors";
import {selectZonasExclusionIsLoading} from "./entities/shared/zonas-exclusion/zonas-exclusion.selectors";
import {selectIngenierosAgronomosIsLoading} from "./entities/shared/ingenieros-agronomos/ingenieros-agronomos.selectors";

export const selectGeoItemsIsLoading = createSelector(
  selectChacrasIsLoading,
  selectChacrasGeoIsLoading,
  selectDibujosIsLoading,
  selectAdjuntosIsLoading,
  selectSuelosIsLoading,
  selectZonasExclusionIsLoading,
  (
    chacrasIsLoading: boolean,
    chacrasGeoIsLoading: boolean,
    dibujosIsLoading: boolean,
    adjuntosIsLoading: boolean,
    suelosIsLoading: boolean,
    zonasExclusionIsLoading: boolean,
  ) => chacrasIsLoading ||
    chacrasGeoIsLoading ||
    dibujosIsLoading ||
    adjuntosIsLoading ||
    suelosIsLoading ||
    zonasExclusionIsLoading
);

export const selectAdminItemsIsLoading = createSelector(
  selectEmpresasIsLoading,
  selectPersonasIsLoading,
  selectRolesIsLoading,
  selectMensajesIsLoading,
  selectCultivosIsLoading,
  selectIngenierosAgronomosIsLoading,
  (
    empresasIsLoading: boolean,
    personasIsLoading: boolean,
    rolesIsLoading: boolean,
    mensajesIsLoading: boolean,
    cultivosIsLoading: boolean,
    ingenierosAgronomosIsLoading: boolean,
  ) =>
    empresasIsLoading ||
    personasIsLoading ||
    rolesIsLoading ||
    mensajesIsLoading ||
    cultivosIsLoading ||
    ingenierosAgronomosIsLoading
);

export const selectFeaturesIsLoading = createSelector(
  selectGeoItemsIsLoading,
  selectAdminItemsIsLoading,
  selectRolesArcgisIsLoading,
  (
    geoIsLoading: boolean,
    adminIsLoading: boolean,
    rolesArcgisIsLoading: boolean,
  ) =>
    geoIsLoading ||
    adminIsLoading ||
    rolesArcgisIsLoading
);

